import { createSelector } from 'reselect';

const selectDiagram = (state) => state.diagram;

export const selectScale = createSelector(
    [selectDiagram],
    (diagram) => diagram.scale
);

export const selectFocusedElementsIds = createSelector(
    [selectDiagram],
    (diagram) => diagram.focusedElementsIds
);
export const selectFocusedLineId = createSelector(
    [selectDiagram],
    (diagram) => diagram.focusedLineId
);
export const selectFocusedAreaId = createSelector(
    [selectDiagram],
    (diagram) => diagram.focusedAreaId
);
export const selectFocusedArea = createSelector(
    [selectDiagram],
    (diagram) => diagram.focusedArea
);

export const selectFocusedInsideElement = createSelector(
    [selectDiagram],
    (diagram) => diagram.focusedInsideElement
);

export const selectThemeMode = createSelector(
    [selectDiagram],
    (diagram) => diagram.themeMode
);

export const selectIsCursorHand = createSelector(
    [selectDiagram],
    (diagram) => diagram.isCursorHand
);

export const selectIsAvailableHistoryUndo = createSelector(
    [selectDiagram],
    (diagram) => diagram.historyIsUndoAvailable
);
export const selectIsAvailableHistoryRedo = createSelector(
    [selectDiagram],
    (diagram) => diagram.historyIsRedoAvailable
);

// -------------------------------------------------------------------------------------

export const selectLines = createSelector(
    [selectDiagram],
    (diagram) => diagram.lines
);

export const selectElementsChanges = createSelector(
    [selectDiagram],
    (diagram) => diagram.elementsChanges
);
export const selectElements = createSelector(
    [selectDiagram],
    (diagram) => diagram.elements
);
export const selectElementsLive = createSelector(
    [selectDiagram],
    (diagram) => diagram.elementsLive
);

export const selectIsBtnNewTableClickEnabled = createSelector(
    [selectDiagram],
    (diagram) => diagram.isBtnNewTableClickEnabled
);
export const selectIsBtnNewTableGrabEnabled = createSelector(
    [selectDiagram],
    (diagram) => diagram.isBtnNewTableGrabEnabled
);

export const selectIsBtnNewNoteClickEnabled = createSelector(
    [selectDiagram],
    (diagram) => diagram.isBtnNewNoteClickEnabled
);
export const selectIsBtnNewNoteGrabEnabled = createSelector(
    [selectDiagram],
    (diagram) => diagram.isBtnNewNoteGrabEnabled
);

export const selectIsBtnNewLineEnabled = createSelector(
    [selectDiagram],
    (diagram) => diagram.isBtnNewLineEnabled
);

export const selectIsBtnNewAreaEnabled = createSelector(
    [selectDiagram],
    (diagram) => diagram.isBtnNewAreaEnabled
);

export const selectIsBtnPenEnabled = createSelector(
    [selectDiagram],
    (diagram) => diagram.isBtnPenEnabled
);

export const selectIsBtnSettingsEnabled = createSelector(
    [selectDiagram],
    (diagram) => diagram.isBtnSettingsEnabled
);
export const selectIsBtnModalShortcutsEnabled = createSelector(
    [selectDiagram],
    (diagram) => diagram.isBtnModalShortcutsEnabled
);

export const selectIsBtnProfileEnabled = createSelector(
    [selectDiagram],
    (diagram) => diagram.isBtnProfileEnabled
);

export const selectIsBtnExportEnabled = createSelector(
    [selectDiagram],
    (diagram) => diagram.isBtnExportEnabled
);
export const selectIsBtnExportImageEnabled = createSelector(
    [selectDiagram],
    (diagram) => diagram.isBtnExportImageEnabled
);
export const selectIsBtnExportCodeEnabled = createSelector(
    [selectDiagram],
    (diagram) => diagram.isBtnExportCodeEnabled
);

export const selectIsBtnSqlSyntaxEnabled = createSelector(
    [selectDiagram],
    (diagram) => diagram.isBtnSqlSyntaxEnabled
);
// export const selectSqlSyntax = createSelector(
//     [selectDiagram],
//     (diagram) => diagram.sqlSyntax
// );

export const selectIsBtnViewModesEnabled = createSelector(
    [selectDiagram],
    (diagram) => diagram.isBtnViewModesEnabled
);

export const selectIsBtnSearchEnabled = createSelector(
    [selectDiagram],
    (diagram) => diagram.isBtnSearchEnabled
);
export const selectIsBtnLeftPanelEnabled = createSelector(
    [selectDiagram],
    (diagram) => diagram.isBtnLeftPanelEnabled
);

export const selectIsBtnPopupNewsEnabled = createSelector(
    [selectDiagram],
    (diagram) => diagram.isBtnPopupNewsEnabled
);


export const selectIsBtnMinimapEnabled = createSelector(
    [selectDiagram],
    (diagram) => diagram.isBtnMinimapEnabled
);
export const selectIsBtnInfoResourcesEnabled = createSelector(
    [selectDiagram],
    (diagram) => diagram.isBtnInfoResourcesEnabled
);

export const selectOriginXY = createSelector(
    [selectDiagram],
    (diagram) => diagram.originXY
);

export const selectFocusedElements = createSelector(
    [selectDiagram],
    (diagram) => diagram.focusedElements
);
export const selectFocusedLine = createSelector(
    [selectDiagram],
    (diagram) => diagram.focusedLine
);

export const selectIsContextMenuShowed = createSelector(
    [selectDiagram],
    (diagram) => diagram.isContextMenuShowed
);

export const selectIsContextMenuVisible = createSelector(
    [selectDiagram],
    (diagram) => diagram.isContextMenuVisible
);

export const selectViewMode = createSelector(
    [selectDiagram],
    (diagram) => diagram.viewMode
);

export const selectIsBtnRedGreenViewEnabled = createSelector(
    [selectDiagram],
    (diagram) => diagram.isBtnRedGreenViewEnabled
);

export const selectAreas = createSelector([selectDiagram], (diagram) => diagram.areas);

export const selectCanvasLimits = createSelector(
    [selectDiagram],
    (diagram) => diagram.canvasLimits
);

export const selectIsHistoryClicked = createSelector(
    [selectDiagram],
    (diagram) => diagram.isHistoryClicked
);

export const selectNewPenProps = createSelector(
    [selectDiagram],
    (diagram) => diagram.newPen
);

export const selectIsEnabledElementDescriptionEditing = createSelector(
    [selectDiagram],
    (diagram) => diagram.isEnabledElementDescriptionEditing
);

export const selectDiagramDetails = createSelector(
    [selectDiagram],
    (diagram) => diagram.diagramDetails
);
export const selectDiagramDbEngine = createSelector(
    [selectDiagram],
    (diagram) => diagram.diagramDbEngine
);





export const selectFocusedGroupElements = createSelector(
    [selectDiagram],
    (diagram) => diagram.focusedGroupElements
);
export const selectFocusedGroupElementsIds = createSelector(
    [selectDiagram],
    (diagram) => diagram.focusedGroupElementsIds
);
export const selectFocusedGroupAreas = createSelector(
    [selectDiagram],
    (diagram) => diagram.focusedGroupAreas
);
export const selectFocusedGroupAreasIds = createSelector(
    [selectDiagram],
    (diagram) => diagram.focusedGroupAreasIds
);


// PRICING PLAN LIMIT
export const selectIsCanvasModalPricingPlanLimitEnabled = createSelector(
    [selectDiagram],
    (diagram) => diagram.isCanvasModalPricingPlanLimitEnabled
);
export const selectCanvasModalPricingPlanLimitType = createSelector(
    [selectDiagram],
    (diagram) => diagram.canvasModalPricingPlanLimitType
);


// PRICING PLAN LIMIT MAX
export const selectIsCanvasModalPricingPlanLimitMaxEnabled = createSelector(
    [selectDiagram],
    (diagram) => diagram.isCanvasModalPricingPlanLimitMaxEnabled
);
export const selectCanvasModalPricingPlanLimitMaxType = createSelector(
    [selectDiagram],
    (diagram) => diagram.canvasModalPricingPlanLimitMaxType
);

// MODAL DIAGRAM EXPORT SQL
export const selectIsModalDiagramExportSqlEnabled = createSelector(
    [selectDiagram],
    (diagram) => diagram.isModalDiagramExportSqlEnabled
);
export const selectModalDiagramExportSqlData = createSelector(
    [selectDiagram],
    (diagram) => diagram.modalDiagramExportSqlData
);

export const selectIsBtnExportImageClickEnabled = createSelector(
    [selectDiagram],
    (diagram) => diagram.isBtnExportImageClickEnabled
);

export const selectIsCanvasGridEnabled = createSelector(
    [selectDiagram],
    (diagram) => diagram.isCanvasGridEnabled
);